// @flow
import React from "react";
import ListItem from "@material-ui/core/ListItem";
import { withStyles } from "@material-ui/core/styles";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Link } from "react-router-dom";
import MaterialList from "@material-ui/core/List";
import type { MenuItem } from "containers/PublicApp/types";

type Props = {
  expanded: number,
  closeDrawer: () => void,
  items: Array<MenuItem>,
  onExpandedChange: (number) => void,
  classes: Object,
  persistent: boolean,
};

const styles = (theme) => ({
  list: {
    width: 310,
    paddingTop: 10,
    //overflowY: "auto",
    top: 77,
    [theme.breakpoints.down("xs")]: {
      top: 56,
      width: 295,
    },
  },
  listPersistent: {
    top: "0px !important",
  },
  nested: {
    paddingLeft: theme.spacing(6),
  },
  titleItem: {
    fontFamily: "Playfair Display, Times, serif",
    fontWeight: 300,
    fontSize: "2.1em",
  },
  titleWrap: {
    paddingRight: "12px",
    position: "relative",
    bottom: "3px",
  },
  listItem: {
    fontSize: "1.2rem",
    fontWeight: 300,
    paddingLeft: 13,
    color: "rgba(0, 0, 0, 0.87)",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    [theme.breakpoints.down("xs")]: {
      fontSize: "1.05rem",
      fontWeight: 400,
    },
  },
});

const MenuLink = withStyles(styles)(
  (props: {
    link: MenuItem,
    spaceLink: string,
    className: string,
    classes: Object,
  }) => {
    const { link, spaceLink, className, classes } = props;
    if (link.newPage) {
      return (
        <ListItem
          button
          component="a"
          href={link.link}
          target="_blank"
          className={className}
        >
          <div className={classes.listItem}>{props.link.name}</div>
        </ListItem>
      );
    }
    if (link.noWiki) {
      return (
        <ListItem button component={Link} to={link.link} className={className}>
          <div className={classes.listItem}>{props.link.name}</div>
        </ListItem>
      );
    }
    const to = spaceLink + link.link;
    return (
      <ListItem button component={Link} to={to} className={className}>
        <div className={classes.listItem}>{props.link.name}</div>
      </ListItem>
    );
  }
);

const DrawerMenuItem = withStyles(styles)((props) => {
  const { space, expanded, handleExpand, closeDrawer, nestedClass, classes } =
    props;
  return (
    <div>
      <ListItem button onClick={handleExpand} className={classes.titleItem}>
        <span className={classes.titleWrap}>{space.name}</span>
        {expanded ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      {space.links && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <div onClick={closeDrawer}>
            {space.links.map((link, index) => {
              let showItem = true;
              if (
                link.expiryDate &&
                link.expiryDate <= new Date().toLocaleDateString()
              ) {
                showItem = false;
              }
              return (
                showItem && (
                  <MenuLink
                    key={index}
                    link={link}
                    spaceLink={space.link}
                    onClick={closeDrawer}
                    className={nestedClass}
                  />
                )
              );
            })}
          </div>
        </Collapse>
      )}
    </div>
  );
});

//mobile menu on the side of most wiki pages
const DrawerMenu = (props: Props) => {
  const {
    classes,
    expanded,
    items,
    closeDrawer,
    onExpandedChange,
    persistent,
  } = props;

  if (items && items.length > 0) {
    return (
      <MaterialList
        dense={false}
        className={`${classes.list} ${
          persistent ? classes.listPersistent : ""
        }`}
      >
        {items.map((space, index) => {
          return (
            <DrawerMenuItem
              closeDrawer={closeDrawer}
              key={index}
              space={space}
              expanded={index === expanded}
              handleExpand={() => onExpandedChange(index)}
              nestedClass={classes.nested}
            />
          );
        })}
      </MaterialList>
    );
  }
  return null;
};

export default withStyles(styles)(DrawerMenu);
